import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-offline-s",
  "use": "app-icon-offline-s-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-offline-s\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M8 1a6.98 6.98 0 00-7 7c0 3.882 3.118 7 7 7s7-3.118 7-7-3.118-7-7-7z\" fill=\"gray\" fill-rule=\"nonzero\" /><path stroke=\"#FFF\" stroke-width=\".875\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.375 8h5.25\" /><path d=\"M0 0h16v16H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol